// extracted by mini-css-extract-plugin
export default {"wrapper":"CoOccuringConditions_wrapper__kqnW6","content":"CoOccuringConditions_content__nNzVU"};